var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'd-flex justify-center': _vm.$isCreditOnline()
  }},[(_vm.$isCreditOnline())?_c('NewRegisterForm',{attrs:{"hideToolbarDialogProp":true}}):_c('RegisterForm',{attrs:{"hideCloseDialogProp":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }